// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_StarRating.scss
// module id = 664
// module chunks = 61 88